<app-skeleton></app-skeleton>
<app-loader *ngIf="loaderService.spinnerShow"></app-loader>
